module.exports = __webpack_public_path__ + "img/2.d8ad0a6a.png";